export const LOADER_MIN_MS = 1600;
export const LOADER_FADE_MS = 900;

export function LoadingScreen({ fadingOut = false }: { fadingOut?: boolean }) {
  return (
    <div
      className={`fixed inset-0 z-[2000] pointer-events-none ${
        fadingOut ? 'loader-exit' : ''
      }`}
    >
      <div className="loader-bg absolute inset-0 bg-white" />
      <div className="loader-runner absolute inset-0 flex items-center justify-center">
        <div className="relative w-28 h-28">
          <Runner />
          <GroundShadow />
        </div>
      </div>
      <div className="loader-orb absolute inset-0" />
    </div>
  );
}

function Runner() {
  return (
    <svg
      viewBox="0 0 90 130"
      aria-hidden
      className="w-full h-full overflow-visible"
      fill="#F25C54"
    >
      <g className="runner-body">
        <Leg className="runner-leg-back" />
        <Arm className="runner-arm-back" />
        <circle cx="47" cy="11" r="9" />
        <path d="M36 22 Q31 44 38 66 Q45 69 53 66 Q57 44 53 22 Q45 18 36 22 Z" />
        <Arm className="runner-arm-front" />
        <Leg className="runner-leg-front" />
      </g>
    </svg>
  );
}

function Arm({ className }: { className: string }) {
  return (
    <g className={className}>
      <line
        x1="45"
        y1="28"
        x2="47"
        y2="60"
        stroke="#F25C54"
        strokeWidth="8"
        strokeLinecap="round"
      />
      <circle cx="47" cy="60" r="4.5" />
    </g>
  );
}

function Leg({ className }: { className: string }) {
  return (
    <g className={className}>
      <polyline
        points="45,66 54,90 46,114"
        fill="none"
        stroke="#F25C54"
        strokeWidth="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  );
}

function GroundShadow() {
  return (
    <div
      className="absolute left-1/2 -translate-x-1/2 bottom-1 h-1.5 rounded-full bg-ink-300/50"
      style={{ width: 48, animation: 'runner-shadow 0.52s ease-in-out infinite' }}
    />
  );
}
